/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Area_Map_Open_GrowerInputs */

const vi_area_map_open_grower = /** @type {(inputs: Area_Map_Open_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở hồ sơ hộ`)
};

/**

* @param {Area_Map_Open_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const area_map_open_grower = /** @type {((inputs?: Area_Map_Open_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Area_Map_Open_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_area_map_open_grower(inputs)
});